var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pane'),_c('div',{staticClass:"container"},[_c('a-upload-dragger',{attrs:{"name":"file","multiple":true,"action":"https://www.mocky.io/v2/5cc8019d300000980a055e76"}},[_c('p',{staticClass:"ant-upload-drag-icon"},[_c('a-icon',{attrs:{"type":"inbox"}})],1),_c('p',{staticClass:"ant-upload-text"},[_vm._v("点击或拖拽文件上传")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }